export enum LocalStorageKeys {
    TOKEN_KEY = 'playerToken',
    NAME_KEY = 'playerName',
    DISCORD_ID_KEY = 'playerDiscordId',
}